import { Component } from '@ecs/Component';

export class TorpedoWeapon implements Component {
  readonly type = 'TorpedoWeapon';

  constructor(
    public cooldown: number = 5000, // 5 seconds between volleys
    public torpedoesPerVolley: number = 2, // Fire 2 torpedoes (one from each side)
    public lastShot: number = 0,
    public torpedoLifetime: number = 300, // 5 seconds at 60fps
    public torpedoColor: string = '#ff8800' // Orange color
  ) {}
}